import actionTypes from '../constants/action-types';

const setToken = (authToken) => ({
  type: actionTypes.SET_TOKEN,
  payload: {
    authToken,
  },
});

export default setToken;
